import { formatRank } from "@memorang/helpers/common";
import { StyleSheet } from "react-native";
import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { LeaderboardAvatar } from "./LeaderboardAvatar";
import { LeaderboardXpAmount } from "./LeaderboardXpAmount";
import type { LeaderboardAvatarType, LeaderboardItem } from "./types";

type Props = LeaderboardItem & {
	isCurrentUser?: boolean;
	avatarType?: LeaderboardAvatarType;
};

export const LeaderboardRankCard = ({
	rank,
	username,
	xp,
	avatar,
	avatarType,
	isCurrentUser = false,
}: Props) => {
	const theme = useAppTheme();

	const isFirst = rank === 1;
	const highlighted = isCurrentUser;

	return (
		<Card
			style={[
				styles.container,
				{
					borderRadius: theme.roundness * 3,
					...(isCurrentUser && {
						backgroundColor: theme.colors.secondaryContainer,
					}),
				},
			]}
		>
			<Card.Content style={styles.content}>
				<Text
					variant="labelLarge"
					style={{
						color:
							highlighted || isFirst
								? theme.colors.primary
								: theme.colors.onSurfaceVariant,
					}}
				>
					{formatRank(rank ?? 0)}
				</Text>
				<Box borderRadius={999} overflow="hidden">
					<LeaderboardAvatar
						username={username}
						size={isFirst ? 56 : 48}
						avatarImage={avatar}
						avatarType={avatarType}
					/>
				</Box>
				<Text
					variant="bodyMedium"
					numberOfLines={1}
					style={[styles.username, { color: theme.colors.onSurface }]}
				>
					{username}
				</Text>
				<LeaderboardXpAmount
					value={xp}
					numberStyle={{
						color: highlighted ? theme.colors.primary : theme.colors.onSurface,
					}}
					unitStyle={[
						styles.xpLabel,
						{
							color: highlighted
								? theme.colors.primary
								: theme.colors.secondary,
							opacity: highlighted ? 0.75 : 1,
						},
					]}
				/>
			</Card.Content>
		</Card>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
	},
	content: {
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 8,
	},
	username: {
		width: "100%",
		textAlign: "center",
	},
	xpLabel: {
		lineHeight: 16,
	},
});
